export const getOrderParamFromSort = (
  sort?: string,
): Record<string, "asc" | "desc"> => {
  switch (sort) {
    case "alphabetical":
      return { name: "asc" };
    case "oldest":
      return { created_at: "asc" };
    case "latest":
      return { created_at: "desc" };
    case "role":
      return { role: "asc" };
    default:
      return { created_at: "desc" };
  }
};
